var map = {
	"./authorize.svg": 1856,
	"./canceled.svg": 1857,
	"./capture.svg": 1858,
	"./card-authentication-line.svg": 1859,
	"./collect-card.svg": 1860,
	"./created.svg": 1861,
	"./failed.svg": 1862,
	"./processing.svg": 1863,
	"./requires-action-line.svg": 1864,
	"./requires-confirmation.svg": 1865,
	"./requires-payment-method.svg": 1866,
	"./succeeded.svg": 1867,
	"./verified.svg": 1868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1855;